import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5ed47a08&scoped=true"
import script from "./component.js?vue&type=script&lang=js&external"
export * from "./component.js?vue&type=script&lang=js&external"
import style0 from "./index.scss?vue&type=style&index=0&id=5ed47a08&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed47a08",
  null
  
)

export default component.exports